<template>
  <div class="crm-dashboard">
    <el-card class="data-work-dynamic" shadow="never">
      <!-- 新增我的待办，超期预警 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="dynamicCard" style="height:380px!important;overflow:visible;">
            <div>
              <el-badge :value="todoData.total === 0 ? '': todoData.total" class="item">
                <div class="cardLeftTopTitle">我的待办</div>
              </el-badge>
              <el-button type="text" class="moreBtn" @click="todoData.dialogVisible = true">更多>></el-button>
            </div>
            <div class="dynamicList" v-for="item in todoData.todoList">
              <div class="dynamicContent">
                <el-tag v-if="item.toDoType === 1" type="success" style="margin-right: 8px">审批</el-tag>
                <el-tag v-if="item.toDoType === 2" style="margin-right: 8px">计划</el-tag>
                <el-tag v-if="item.toDoType === 4" type="warning" style="margin-right: 8px">报销付款</el-tag>
                <el-tag v-if="item.toDoType === 3" type="warning" style="margin-right: 8px">资产</el-tag>
                <span class="text-danger " v-if="item.overdueFlag">已超期</span>
                {{ item.toDoContent }}
              </div>
              <el-button type="text" class="toDetailBtn" @click="toDetail(item)" style="margin-top:-22px;">
                <template v-if="item.toDoType === 1">去审批</template>
                <template v-else-if="item.toDoType === 4">去登记付款</template>
                <template v-else-if="item.toDoType === 2">
                  去完成
                </template>
                <template v-else>去处理</template>
              </el-button>
            </div>
            <div v-if="!todoData.todoList || todoData.todoList.length===0" class="noDataTip">暂无数据</div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <!-- 我的关注，工作动态 -->
          <el-card class="dynamicCard" style="height:380px!important;overflow:visible;">
            <el-button type="text" class="moreBtn" @click="showMoreDynamicList(dynamicType)" style="position:absolute;right:40px;z-index:99;">更多>></el-button>
            <el-tabs v-model="dynamicType" @tab-click="getDynamicListByType(1)">
              <el-tab-pane label="我的关注" name="3">
              </el-tab-pane>
              <el-tab-pane label="@我的" name="4">
              </el-tab-pane>
              <el-tab-pane label="工作动态" name="1">
              </el-tab-pane>
              <el-tab-pane label="系统通知" name="2">
              </el-tab-pane>
            </el-tabs>
            <div v-loading="dynamicLoading">
              <div class="dynamicList" v-for="item in followReplyList">
                <div>{{ item.createTimeStr }}</div>
                <div class="dynamicContent">{{ item.content }}</div>
                <el-button type="text" class="toDetailBtn" @click="toDetail(item)">查看</el-button>
              </div>
            </div>
            <div v-if="!followReplyList || followReplyList.length===0" class="noDataTip">暂无数据</div>
          </el-card>
          <!--          <el-card class="dynamicCard"  style="height:375px!important;overflow:visible;">-->
          <!--            <div>-->
          <!--              <div class="cardLeftTopTitle">-->
          <!--                超期预警-->
          <!--                <el-button type="text" class="moreBtn" @click="overdueData.dialogVisible = true">更多>></el-button>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <el-row>-->
          <!--              <el-form ref="queryParams" :model="queryParams" label-width="80px" style="width:155%;">-->
          <!--                <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :auto-select-dept="true" @auto-selected="queryData" userIdField="managerIdList"></dept-user-select>-->
          <!--                <el-col :span="6" :offset="1" align="left">-->
          <!--                  <el-button type="primary" @click="queryData">筛选</el-button>-->
          <!--                </el-col>-->
          <!--              </el-form>-->
          <!--            </el-row>-->
          <!--            <el-row>-->
          <!--              <el-col :span="10">-->
          <!--                <PieChart style="height:250px;width:100%;" :dataObj="overdueRate"/>-->
          <!--              </el-col>-->
          <!--              <el-col :span="14">-->
          <!--                <div class="dynamicList" style="margin-top:18px;padding-bottom:18px;" v-for="item in overdueData.overdueList">-->
          <!--                  <div class="dynamicContent">商机：{{item.businessName}}已超期<span class="text-danger">{{item.followOverdueDays}}天</span>未跟进</div>-->
          <!--                  <el-button type="text" class="toDetailBtn" @click="toBusinessDetail(item)">查看</el-button>-->
          <!--                </div>-->
          <!--                <div v-if="!overdueData.overdueList || overdueData.overdueList.length===0" class="noDataTip">暂无数据</div>-->
          <!--              </el-col>-->
          <!--            </el-row>-->

          <!--          </el-card>-->
        </el-col>
      </el-row>
    </el-card>
    <el-row style="margin-top: 30px">
      <el-form ref="dashBoardForm" :model="dashBoardForm" label-width="80px">
        <dept-user-select ref="deptUserSelectRef" :formParam="dashBoardForm" :user-label="'用户'" :user-id-field="'userIdList'"></dept-user-select>
        <el-col :span="6" :offset="1" align="left">
          <el-button type="primary" @click="queryDataBriefing">筛选</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>数据简报</span>
        <span class="moreBtn">
          <span class="date-title">日期</span>
          <el-date-picker
            v-model="briefDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            @change="getDataBriefing"
            :clearable="false"
            size="mini">
          </el-date-picker>
        </span>

      </div>
      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toCustomer">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{briefingData.newAddCustomerCount}}</div>
                <div class="label">新增客户</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div  @click="toCLue">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{briefingData.newAddClueCount}}</div>
                <div class="label">新增线索</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toContact">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{briefingData.newAddContactCount}}</div>
                <div class="label">新增联系人</div>
              </div>
            </el-card>
          </div>
        </el-col>

        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toBusiness">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{briefingData.convertBusinessCount}}</div>
                <div class="label">转化商机</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toBusiness">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{briefingData.newAddBusinessCount}}</div>
                <div class="label">新增商机</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toBusiness('deal')">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(briefingData.estimateDealAmount/10000)}}万</div>
                <div class="label">预计成交金额(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toContract('sign')">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(briefingData.signAmount/10000)}}万</div>
                <div class="label">签约金额(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="3">
          <div @click="toContract">
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(briefingData.fundAmount/10000)}}万</div>
                <div class="label">回款金额(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>


    <el-card class="data-funnel" shadow="never">
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="14">
          <el-card style="height: 400px">
            <div class="cardLeftTopTitle">
              <span class="text-black">业绩达标情况</span>
              <span class="moreOption">
                <span class="text-black">年份 </span>
                <el-date-picker
                  v-model="kpiDate"
                  style="width:100px"
                  type="year"
                  size="mini"
                  value-format="yyyy"
                  placeholder="选择年"
                  @change="queryPerformanceAchieveInfo"
                  :clearable="false"
                  >
                </el-date-picker>
              </span>
            </div>
            <el-row>
              <el-col :xs="24" :md="12" :lg="12">
                <GaugeChart name="target" title="签约达成率" :data="performanceData.signAchieveRete" style="width:100%;height:250px"/>
                <div class="title-left ">年度预算目标：<span class="text-success">{{amountFormat((performanceData.signTargetAmount))}} 万元</span></div>
                <div class="title-left mt10">实际签约：<span class="text-success">{{amountFormat((performanceData.actualSignAmount))}} 万元</span></div>
              </el-col>
              <el-col :xs="24" :md="12" :lg="12">
                <GaugeChart name="refund" title="回款达成率" :data="performanceData.fundAchieveRete" style="width:100%;height:250px"/>
                <div class="title-left">年度预算目标：<span class="text-success">{{amountFormat((performanceData.fundTargetAmount))}} 万元</span></div>
                <div class="title-left mt10">实际回款：<span class="text-success">{{amountFormat((performanceData.actualFundAmount))}} 万元</span></div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :xs="24" :md="12" :lg="10">
          <el-card style="height: 400px">
            <div class="cardLeftTopTitle">
              <span class="text-black">商机漏斗</span>
              <span class="moreOption">
                <span class="text-black">日期 </span>
                <el-date-picker
                  style="width:220px"
                  v-model="businessDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期"
                  @change="queryBusinessFunnel"
                  :clearable="false"
                  size="mini">
                </el-date-picker>
              </span>
            </div>
            <FunnelChart :data="funnelData" height="200px"/>
          </el-card>
        </el-col>
        <!-- <el-col :xs="24" :md="12" :lg="12">
          <el-card shadow="never" style="height: 522px">
            <el-row>
              <el-col :span="12">
                <div class="cardLeftTopTitle">商机趋势</div>
              </el-col>
              <el-col :span="12" align="right">
                <div class="yearPicker">
                  <span style="font-size: 14px">年份：</span>
                  <el-date-picker v-model="dashBoardForm.year" type="year" @change="dateChange"
                                  value-format="yyyy" style="margin-top: 10px; width: 120px" placeholder="请选择年份"/>
                </div>
              </el-col>
            </el-row>
            <el-tabs v-model="businessTrendActiveName" @tab-click="businessTrendTabClick" :stretch="true">
              <el-tab-pane label="新增商机" name="newBusiness">
                <BusinessTrendChart v-if="businessTrendActiveName === 'newBusiness'" :chartData="newBusinessTrendData"/>
              </el-tab-pane>
              <el-tab-pane label="赢单商机" name="winBusiness">
                <BusinessTrendChart v-if="businessTrendActiveName === 'winBusiness'" :chartData="winBusinessTrendData"/>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col> -->
      </el-row>
    </el-card>

    <!--工作动态列表弹窗-->
    <el-dialog :title="dynamicListTitle" :visible.sync="dynamicListVisible" width="60%" :close-on-click-modal="false" :lock-scroll="true" @close="queryDynamicListParams.pageNum = 1">
      <div v-if="!followReplyAllList || followReplyAllList.length===0" class="noDataTip">暂无数据</div>
      <div v-loading="dynamicLoading2">
        <div class="dynamicList2" v-for="item in followReplyAllList">
          <div>{{ item.createTimeStr }}</div>
          <div class="dynamicContent">{{ item.content }}</div>
          <el-button type="text" class="toDetailBtn" @click="toDetail(item)">查看</el-button>
        </div>
      </div>
      <pagination v-show="dynamicTotal>0" :total="dynamicTotal" :page.sync="queryDynamicListParams.pageNum"  :pageSizes="pageSizes"
                  :limit.sync="queryDynamicListParams.pageSize" @pagination="getDynamicListByType(2)"/>
    </el-dialog>
    <!--超期列表弹窗-->
<!--    <el-dialog title="超期预警" :visible.sync="overdueData.dialogVisible" width="45%" :close-on-click-modal="false">-->
<!--      <div v-if="!overdueData.overdueAllList || overdueData.overdueAllList.length===0" class="noDataTip">暂无数据</div>-->
<!--      <div class="dynamicList" v-for="item in overdueData.overdueAllList">-->
<!--        &lt;!&ndash; <div>{{item.createTimeStr}}</div> &ndash;&gt;-->
<!--        <div class="dynamicContent">商机：{{item.businessName}}已超期<span class="text-danger">{{item.followOverdueDays}}天</span>未跟进</div>-->
<!--        <el-button type="text" class="toDetailBtn" @click="toBusinessDetail(item)">查看</el-button>-->
<!--      </div>-->
<!--      <pagination v-show="overdueData.total>0" :total="overdueData.total" :page.sync="overdueData.pageNum" :pageSizes="pageSizes"-->
<!--                  :limit.sync="overdueData.pageSize" @pagination="queryFollowOverdueList"/>-->
<!--    </el-dialog>-->
    <!--我的待办列表弹窗-->
    <el-dialog title="我的待办" :visible.sync="todoData.dialogVisible" width="45%" :close-on-click-modal="false">
      <div v-if="!todoData.todoAllList || todoData.todoAllList.length===0" class="noDataTip">暂无数据</div>
      <div v-loading="toDoLoading">
        <div class="dynamicList" v-for="item in todoData.todoAllList">
          <div class="dynamicContent">
            <el-tag v-if="item.toDoType === 1" type="success" style="margin-right: 8px">审批</el-tag>
            <el-tag v-if="item.toDoType === 2" style="margin-right: 8px">计划</el-tag>
            <el-tag v-if="item.toDoType === 4" type="warning" style="margin-right: 8px">报销付款</el-tag>
                <el-tag v-if="item.toDoType === 3" type="warning" style="margin-right: 8px">资产</el-tag>
            <span class="text-danger " v-if="item.overdueFlag">已超期</span>
            {{ item.toDoContent }}
          </div>
          <el-button type="text" class="toDetailBtn" @click="toDetail(item)">
            <template v-if="item.toDoType === 1">去审批</template>
            <template v-else-if="item.toDoType === 4">去登记付款</template>
                <template v-else-if="item.toDoType === 2">
              去完成
            </template>
            <template v-else>去处理</template>
          </el-button>
        </div>
      </div>
      <pagination v-show="todoData.total>0" :total="todoData.total" :page.sync="todoData.pageNum" :pageSizes="pageSizes"
                  :limit.sync="todoData.pageSize" @pagination="queryMyToDoList()"/>
    </el-dialog>
  </div>
</template>

<script>
import FunnelChart from "@/views/crm/components/funnelHighcharts";
import GaugeChart from "@/views/crm/components/gaugeCharts";
import PieChart from "@/views/crm/components/pieCharts";
import {
  businessFunnel,
  dataBriefing,
  myToDoList,
  performanceAchieveInfo,
  queryBusinessTrend,
  queryDynamicListByPage,
  queryFollowOverdueList,
  queryFollowOverdueRate,
} from "@/api/crm/dashBoard";
import {amountFormat} from '@/utils/index'
import BusinessTrendChart from "@/views/crm/dashboard/businessTrendChart";
import {mapState} from 'vuex'
import deptUserSelect from "@/views/crm/components/deptUserSelect";

export default {
  name: "index",
  props: {
  },
  data() {
    return {
      amountFormat,
      dynamicType: '2',
      pageSizes: [5, 10, 20, 30, 50],
      funnelData: [],
      newBusinessTrendData: {
        dataType: 1,
        data: []
      },
      winBusinessTrendData: {
        dataType: 2,
        data: []
      },
      data: {},
      briefingData: {}, // 数据简报
      briefDate: [], // 数据简报选中时间
      businessDate: [], // 商机漏斗选中时间
      kpiDate: '', // 业绩达标选中时间
      overdueRate: [],// 超期占比
      overdueData: { // 超期数据
        overdueList: [], // 超期列表
        overdueAllList: [],
        total: 0,
        pageNum: 1,
        pageSize: 5,
        dialogVisible: false
      },
      queryParams: {
        deptIdList: [],
        managerIdList: []
      },
      todoData: { // 我的待办
        todoList: [],
        todoAllList: [], // 我的待办全部
        pageNum: 1,
        pageSize: 6,
        dialogVisible: false
      },
      performanceData: {}, // 业绩达成情况
      dynamicLoading: false,
      dynamicLoading2: false,
      toDoLoading: false,
      followReplyList: [], // 我的关注，@，工作动态，系统通知
      followReplyAllList: [], // 我的关注，@，工作动态，系统通知 所有
      systemNoticeList: [],
      dynamicTotal: 0,
      dynamicList: [],
      dynamicListVisible: false,
      dynamicListTitle: '',
      queryDynamicListParams: {
        pageNum: 1,
        pageSize: 10,
        dynamicType: null
      },
      dashBoardForm: {
        deptIdList: [],
        userIdList: [],
        year: new Date().getFullYear().toString(),
        dataType: 1 // 数据类型 1-新建商机 2-赢单商机
      },
      deptOptions: [],
      userOptions: [],
      businessTrendActiveName: 'newBusiness',
      userSelectClearableFlag: true
    };
  },
  mounted() {
    this.init() // 设置当前到年月日
    this.queryDynamicList()
    // this.queryFollowOverdueList() // 超期列表
    // this.queryFollowOverdueRate() // 超期天数占比
    this.queryMyToDoList(1) // 我的待办
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      dept: state => state.user.dept,
      userDataScope: state => state.user.userDataScope
    })
  },
  components: {
    FunnelChart,
    GaugeChart,
    PieChart,
    BusinessTrendChart,
    deptUserSelect
  },
  watch: {
  },
  methods: {
    init(){
      let date = new Date();
      let year,month,day
      year = date.getFullYear()
      month = date.getMonth() + 1
      day = date.getDate()
      this.kpiDate = `${year}`
      this.briefDate = [`${year}-${month < 10 ? '0'+month : month}-01`,`${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`]
      this.businessDate = [`${year}-${month}-1`,`${year}-${month}-${day}`]

      this.dashBoardForm.userIdList = [this.currentUserId]
      this.getDataBriefing() // 查询数据简报
      this.queryBusinessFunnel()  // 商机漏斗
      this.queryPerformanceAchieveInfo() // 业绩达成
    },
    // 超期列表
    queryFollowOverdueList(){
      queryFollowOverdueList({
        pageNum: this.overdueData.pageNum,
        pageSize: this.overdueData.pageSize,
        ...this.queryParams
      }).then(response => {
        if(this.overdueData.pageNum === 1 && this.overdueData.pageSize === 5){
          this.overdueData.overdueList = response.rows;
        }
        this.overdueData.overdueAllList = response.rows;
        this.overdueData.total = response.total
      });
    },
    // 超期占比
    queryFollowOverdueRate(){
      queryFollowOverdueRate(this.queryParams).then(response => {
        this.overdueRate = response.data;
      });
    },
    queryDynamicList() {
      // 动态类型 1-跟进回复 1-系统通知
      this.queryDynamicListParams.pageNum = 1
      this.queryDynamicListParams.pageSize = 5
      this.getDynamicListByType()
    },
    queryData () {
      this.queryFollowOverdueRate()
      this.queryFollowOverdueList()
    },
    // 数据简报
    queryDataBriefing (){
      this.getDataBriefing() // 查询数据简报
      this.queryBusinessFunnel()  // 商机漏斗
      this.queryPerformanceAchieveInfo() // 业绩达成
    },
    getDataBriefing() {
      dataBriefing({
        ...this.dashBoardForm,
        timeStart: this.briefDate[0],
        timeEnd: this.briefDate[1]
      }).then(response => {
        this.briefingData = response.data;
      });
    },
    // 查询我的待办
    queryMyToDoList(){
      this.toDoLoading = true
      myToDoList({
        pageNum: this.todoData.pageNum,
        pageSize: this.todoData.pageSize
      }).then(response => {
        // 首页
        if(this.todoData.pageNum === 1 && this.todoData.pageSize === 6){
          this.todoData.todoList = response.rows
        }
        this.todoData.todoAllList = response.rows
        this.todoData.total = response.total
      }).finally(()=> {
          this.toDoLoading = false
      });
    },
    // 业绩达成
    queryPerformanceAchieveInfo(){
      performanceAchieveInfo({
        ...this.dashBoardForm,
        year: this.kpiDate
      }).then(response => {
        this.performanceData = response.data
      });
    },
    // 查询商机漏斗
    queryBusinessFunnel(){
      businessFunnel({
        ...this.dashBoardForm,
        timeStart: this.businessDate[0],
        timeEnd: this.businessDate[1]
      }).then(response => {
        this.funnelData = this.getFunnelData(response.data);
      });
    },
    // queryDashBoardData () {
    //   queryDashBoard(this.dashBoardForm).then(response => {
    //     this.data = response.data;
    //     this.funnelData = this.getFunnelData(this.data.salesFunnelVos);
    //   });
    //   this.queryBusinessTrendByParam()
    // },
    queryBusinessTrendByParam () {
      // 查询商机趋势
      queryBusinessTrend(this.dashBoardForm).then(response => {
        // dataType 数据类型 1-新建商机 2-赢单商机
        if (this.dashBoardForm.dataType === 1) {
          let newBusinessData = []
          response.data.newBusinessTrendList.forEach(item => {
            newBusinessData.push(item.count)
          })
          this.newBusinessTrendData.data = newBusinessData
        } else if (this.dashBoardForm.dataType === 2) {
          let winBusinessData = []
          response.data.winBusinessTrendList.forEach(item => {
            winBusinessData.push(item.count)
          })
          this.winBusinessTrendData.data = winBusinessData
        }
      });
    },
    businessTrendTabClick (tab) {
      if (tab.name === 'newBusiness') {
        this.dashBoardForm.dataType = 1
      } else if (tab.name === 'winBusiness') {
        this.dashBoardForm.dataType = 2
      }
      this.queryBusinessTrendByParam()
    },
    getDynamicListByType (queryType) {
      let queryParam = {
        pageNum: this.queryDynamicListParams.pageNum,
        pageSize: this.queryDynamicListParams.pageSize,
        dynamicType: this.dynamicType
      }
      if (queryType === 1) {
        this.dynamicLoading = true
      } else if (queryType === 2) {
        this.dynamicLoading2 = true
      }
      queryDynamicListByPage(queryParam).then(response => {
        // dynamicType ： 1-跟进回复 2-系统通知 3-关注动态 4-@通知
        if (this.queryDynamicListParams.pageNum === 1 && this.queryDynamicListParams.pageSize === 5) {
          this.followReplyList = response.rows || []
        }
        this.followReplyAllList = response.rows || []
        this.dynamicTotal = response.total
      }).finally(() => {
        if (queryType === 1) {
          this.dynamicLoading = false
        } else if (queryType === 2) {
          this.dynamicLoading2 = false
        }
      });
    },
    // /** 查询部门下拉树结构 */
    // getTreeselect() {
    //   treeselect().then(response => {
    //     if (!response.data || response.data.length === 0) {
    //       this.deptOptions = [{id: this.dept.deptId, label: this.dept.deptName}]
    //     } else {
    //       this.deptOptions = response.data
    //     }
    //     // 仅本人数据时，人员下拉框不能清除 用户数据权限范围（10：所有数据权限；20：仅本人数据权限 30：有部门数据权限）
    //     if (this.userDataScope === '20') {
    //       this.userSelectClearableFlag = false
    //     }
    //     // 进入页面时选择用户所在部门
    //     this.dashBoardForm.deptId = this.dept.deptId
    //     // 进入页面时选择当前用户
    //     listUser({deptId: this.dashBoardForm.deptId}).then(response2 => {
    //       this.userOptions = response2.rows;
    //       this.dashBoardForm.userId = this.currentUserId
    //       // this.queryDashBoardData()
    //       this.getDataBriefing() // 查询数据简报
    //       this.queryBusinessFunnel()  // 商机漏斗
    //       this.queryPerformanceAchieveInfo() // 业绩达成
    //     });
    //   });
    // },
    // deptSelect (node, instanceId) {
    //   this.userOptions = []
    //   // 仅本人数据时，不清除当前查询用户
    //   if (this.userDataScope !== '20') {
    //     this.dashBoardForm.userId = null
    //   }
    //   listUser({deptId: node.id}).then(response => {
    //     this.userOptions = response.rows;
    //   });
    // },
    getFunnelData(originData) {
      let funnelData = []
      originData.forEach(item => {
        funnelData.push({
          name: item.saleStageDesc,
          value: item.totalAmount
        })
      });
      return funnelData;
    },
    dateChange (year) {
      this.dashBoardForm.year = year
      this.queryBusinessTrendByParam()
    },
    toCLue () {
      this.$router.push({
        name: "/crm/clue/manage",
        params: {
          deptIdList: this.dashBoardForm.deptIdList,
          managerIdList: this.dashBoardForm.userIdList,
          createTime: this.briefDate
        }
      });
    },
    toCustomer () {
      this.$router.push({
        name: "/crm/customer/manage",
        params: {
          deptIdList: this.dashBoardForm.deptIdList,
          managerIdList: this.dashBoardForm.userIdList,
          createTime: this.briefDate
        }
      });
    },
    toContact () {
      this.$router.push({
        name: "/crm/contact/manage",
        params: {
          deptIdList: this.dashBoardForm.deptIdList,
          managerIdList: this.dashBoardForm.userIdList,
          createTime: this.briefDate
        }
      });
    },
    toBusiness (type) {
      this.$router.push({
        name: "/crm/business/manage",
        params: {
          deptIdList: this.dashBoardForm.deptIdList,
          managerIdList: this.dashBoardForm.userIdList,
          createTime: type !== 'deal' ? this.briefDate : '',
          estimateDealDate: type === 'deal' ? this.briefDate: '' // 预计成交时间
        }
      });
    },
    toContract (type) {
      this.$router.push({
        name: "/crm/contract/manage",
        params: {
          deptIdList: this.dashBoardForm.deptIdList,
          managerIdList: this.dashBoardForm.userIdList,
          signTime: type === 'sign' ? this.briefDate: '',
          actualFundDate: type !== 'sign' ? this.briefDate: ''
        }
      });
    },
    showMoreDynamicList (dynamicType) {
      this.queryDynamicListParams.pageNum = 1
      this.queryDynamicListParams.pageSize = 5
      if (dynamicType == 1) {
        this.dynamicListTitle = '工作动态列表'
      } else if (dynamicType == 2) {
        this.dynamicListTitle = '系统通知列表'
      } else if (dynamicType == 3) {
        this.dynamicListTitle = '我的关注列表'
      } else if (dynamicType == 4) {
        this.dynamicListTitle = '@我的列表'
      }
      this.dynamicListVisible = true
    },
    getDynamicList () {
      queryDynamicListByPage(this.queryDynamicListParams).then(response => {
        this.dynamicList = response.rows || []
        this.dynamicTotal = response.total || 0
      });
    },
    toDetail (item) {
      let url = ''
      // 回款计划
      if (item.targetType === 'contractPlanFund') {
        url = '/crm/plan-fund/detail/' + item.targetId
      } else if (item.targetType === 'contractFundRecord') {
        // 回款记录
        url = '/crm/fund-record/detail/' + item.targetId
      } else if (item.targetType === 'contractInvoice') {
        // 发票
        url = '/crm/invoice/detail/' + item.targetId
      } else if (['purchaseApply', 'procurement', 'purchase_apply'].includes(item.targetType)) {
        // 采购申请审批
        url = '/procurement/apply/detail/' + item.targetId
      } else if (item.targetType === 'expenseClaim') {
        url = '/finance/expense/detail/' + item.targetId
      } else if (['paymentApplication', 'loanApplication', 'invoiceApplication'].includes(item.targetType)) {
        const type = { paymentApplication: 'PAYMENT', loanApplication: 'LOAN', invoiceApplication: 'INVOICE' }[item.targetType]
        url = '/finance/applications/' + type + '/detail/' + item.targetId
      } else if (item.targetType === 'assetRepair') {
        // 资产报废审批：目标 id 是报修记录，待办 id 是审批工单。
        url = '/assetManagement/assetRepairApproval/' + item.targetId + '?workOrderId=' + item.toDoId
      } else if (['assetOperation', 'assetStocktake'].includes(item.targetType)) {
        url = item.targetType === 'assetStocktake'
          ? '/assetManagement/assetStocktake'
          : '/assetManagement/myAssets?tab=pending'
      } else if (item.targetType === 'assetClaim') {
        url = '/assetManagement/assetTodo?tab=claim'
      } else if (item.targetType === 'assetReturn') {
        url = '/assetManagement/assetTodo?tab=todo'
      } else if (item.targetType === 'assetRepairTask') {
        url = '/assetManagement/assetTodo?tab=repair'
      } else {
        // 其他路径和targetType一样
        url = '/crm/' + item.targetType + '/detail/' + item.targetId
      }
      this.$router.push(url);
    },
    toBusinessDetail(item){
      this.$router.push(`/crm/business/detail/${item.businessId}`);
    }
  }
};
</script>

<style lang='scss' scoped>
.title-left{
  margin-left: 30%;
  font-size: 14px;
}

.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 30px;
        }
        .value {
          font-weight: 400;
          padding-top: 20px;
        }
      }
    }
    .data-card:hover {
      color: #4480F3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
      cursor: pointer;
    }
    // .data-card:hover {
    //   color: #303133;
    //   border-color: #e6ebf5;
    //   background-color: #FFFFFF;
    //   cursor: default;
    // }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -10px!important;
  }
  .moreOption{
    position: absolute;
    right: 0;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    position: relative;
    color: #9ea1a7;
    font-size: 14px;
    line-height: 30px;
  }

  .dynamicCard {
    min-height: 100px;
    height: 220px;
  }

  .noDataTip {
    height: 241px;
    margin-left: 0;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dynamicContent {
    margin-top: 8px;
    width:85%;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
.date-title{
  font-size: 14px;
  display: inline-block;
  line-height: 29px;
  float: left;
  margin-right: 5px;
  font-weight: normal;
}
::v-deep .el-badge__content.is-fixed{
  top: 14px;
  right: 0
}
</style>
